export default __webpack_public_path__ + "static/media/04-small.a8e858f7.jpg";